import CITATION from './citation'
import { TweenMax } from 'gsap'

export default {
  name: 'loader',
  data () {
    return {
      active: true,
      dissmissed: false,
      text: '',
      author: '',
      bgc: {
        backgroundColor: ''
      },
      citationFtsz: {
        fontSize: '',
        lineHeight: ''
      },
      lineHeight: 0,
      pickedCitation: null,
      readingTime: false
    }
  },

  created () {
    this.$store.state.loader = this
  },

  mounted () {
    var quote = window.quote ? window.quote : CITATION

    this.text = quote.text
    this.author = quote.author
    this.bgc.backgroundColor = quote.color
    this.citationFtsz.fontSize = quote.fontSize
    this.citationFtsz.lineHeight = quote.lineHeight

    this.pickedCitation = quote

    this.$nextTick(() => {
      this.lineSplit()
      this.$nextTick(() => {
        this.$store.state.transition.components.default.bgc.backgroundColor = quote.color
        this.$store.state.transition.components.default.overideHide = true
        this.$store.state.transition.components.default.glxp.offset = 0
        this.$store.state.transition.components.default.glxp.shift = 0
        this.$store.state.transition.components.default.show()
        this.$nextTick(() => {
          this.bgc.backgroundColor = null
        })
      })
    })
  },
  methods: {

    lineSplit () {
      this.splited = new SplitText(this.$el.querySelector('.loader-citation'), { type: 'lines' })
      this.$nextTick(() => {
        this.lines = this.$el.querySelectorAll('.loader-citation > div')
        for (let i = 0; i < this.lines.length; i++) {
          const line = this.lines[i]
          line.classList.add('loader-citation-line-wrapper')
          line.innerHTML =
          `<span class="loader-citation-line" style="transition-delay: ${i * (1 / (this.lines.length * 3))}s">` +
          line.innerHTML +
          `</span>`
        }
        this.show()
      })
    },

    show () {
      setTimeout(() => {
        this.$el.classList.remove('in')
      }, 200)
      setTimeout(() => {
        this.$refs['author'].style.opacity = 1

        setTimeout(() => {
          this.readingTime = true
        }, 100)
      }, 1200)
    },

    hide () {
      if (this.active == false) { return } // case in transition page
      if (!this.readingTime) {
        setTimeout(() => {
          this.hide()
        }, 100)
        return
      }
      setTimeout(() => {
        this.active = false
        this.$nextTick(() => {
          this.$el.classList.remove('in')
        })
        this.$refs['author'].style.opacity = 0
      }, 1000)
      setTimeout(() => {
        this.dissmissed = true
        this.$store.state.transition.components.default.overideHide = false
        this.$store.state.transition.components.default.hide()
        setTimeout(() => {
          this.$store.state.transition.components.default.glxp.showLogo = true
        }, 1500)
        if (this.$router.currentRoute.name === 'partenaires' || this.$router.currentRoute.name === 'partners' || this.$router.currentRoute.name === 'philosophy' || this.$router.currentRoute.name === 'philosophie') {
        } else {
          document.querySelector('html').classList.remove('preventScroll')
        }
      }, 2000)
    }
  }

}
